export const avatarRules = Object.freeze({
    fieldName:"avatar",
    outputFormat:"jpeg",
    outputName:"avatar.jpg",
    outputType:"image/jpeg",
    height:512,
    maxSize:5 * 1024 * 1024,
    types:Object.freeze(["image/jpeg", "image/png", "image/webp"]),
    width:512
});

const avatarTypeMap = Object.freeze(Object.fromEntries(
    avatarRules.types.map(type=>[type, true])
));

const avatarFormats = Object.freeze({
    jpeg:true,
    png:true,
    webp:true
});

export const isAvatarTypeAllowed = type=>!!avatarTypeMap[type];

export const isAvatarFormatAllowed = format=>!!avatarFormats[format];

export const isAvatarSizeAllowed = size=>{
    return Number.isFinite(size) && size > 0 && size <= avatarRules.maxSize;
};

export const hasAvatarDimensions = (width, height)=>{
    return width === avatarRules.width && height === avatarRules.height;
};

export const validateAvatarFileMeta = file=>{
    if (!file) {
        return { isValid:false, error:"missing_avatar" };
    }
    if (!isAvatarTypeAllowed(file.type)) {
        return { isValid:false, error:"invalid_avatar_type" };
    }
    if (!isAvatarSizeAllowed(file.size)) {
        return { isValid:false, error:"invalid_avatar_size" };
    }
    return { isValid:true, values:{ type:file.type, size:file.size } };
};
